import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "mall-my-list" }
const _hoisted_2 = {
  key: 0,
  class: "mall-my-list__empty"
}
const _hoisted_3 = {
  key: 1,
  class: "mall-my-list__empty"
}
const _hoisted_4 = {
  key: 2,
  class: "mall-my-list__cards"
}
const _hoisted_5 = { class: "mall-my-list__meta" }
const _hoisted_6 = { class: "mall-my-list__title" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "mall-my-list__sub" }
const _hoisted_9 = { class: "mall-my-list__actions" }

import { onMounted, ref } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'
import { MALL_ORDER_STATUS_LABEL, fetchMyOrders, type MallOrder } from '@/api/mallOrder'
import { formatPrice } from '@/constants/mallProducts'
import { MALL_HOME_PATH } from '@/constants/mall'


export default /*@__PURE__*/_defineComponent({
  __name: 'MallMyStatementsPage',
  setup(__props) {

const loading = ref(true)
const orders = ref<MallOrder[]>([])

function formatDate(value: string | null | undefined) {
  return String(value || '').slice(0, 10).replace(/-/g, '.')
}

onMounted(async () => {
  loading.value = true
  try {
    const rows = await fetchMyOrders()
    orders.value = rows.filter((order) => order.status === 'PAID')
  } catch {
    orders.value = []
  } finally {
    loading.value = false
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("header", { class: "mall-my-list__head" }, [
      _createElementVNode("h1", null, "거래명세서 조회"),
      _createElementVNode("p", null, "결제 완료된 주문의 거래명세서를 인쇄할 수 있습니다.")
    ], -1)),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "불러오는 중입니다…"))
      : (!orders.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(AppIcon, {
              icon: "mdi-file-document-outline",
              size: 48
            }),
            _cache[1] || (_cache[1] = _createElementVNode("p", null, "출력할 거래명세서가 없습니다", -1)),
            _cache[2] || (_cache[2] = _createElementVNode("em", null, "결제 완료된 주문만 여기에 나타납니다.", -1)),
            _createVNode(_component_router_link, { to: _unref(MALL_HOME_PATH) }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode("쇼핑계속하기", -1)
              ]))]),
              _: 1
            }, 8, ["to"])
          ]))
        : (_openBlock(), _createElementBlock("ul", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orders.value, (order) => {
              return (_openBlock(), _createElementBlock("li", {
                key: order.code
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("strong", null, _toDisplayString(order.code), 1),
                  _createElementVNode("time", null, _toDisplayString(formatDate(order.paidAt || order.orderedAt)), 1)
                ]),
                _createElementVNode("p", _hoisted_6, [
                  _createTextVNode(_toDisplayString(order.itemSummary || '주문 상품') + " ", 1),
                  (order.itemCount > 1)
                    ? (_openBlock(), _createElementBlock("em", _hoisted_7, " 외 " + _toDisplayString(order.itemCount - 1) + "건", 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("p", _hoisted_8, _toDisplayString(order.payMethod === 'TOSS' ? '결제 완료' : '입금 확인') + " · " + _toDisplayString(_unref(formatPrice)(order.totalAmount)) + "원 ", 1),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_router_link, {
                    to: `/mall/orders/${order.code}`
                  }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode("거래명세서 보기 · 인쇄", -1)
                    ]))]),
                    _: 1
                  }, 8, ["to"])
                ])
              ]))
            }), 128))
          ]))
  ]))
}
}

})